import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ConfigureWACampaignModal = React.lazy(
  () => import("./configure-wa-campaign.modal"),
);

const ConfigureWACampaign: iModalProps<
  typeof ConfigureWACampaignModal,
  {
    campaignId: string;
    mode?: "SEND" | "EDIT";
  }
> = {
  name: "configure-wa-marketing-campaign",
  component: GenerateModalWithSuspense(ConfigureWACampaignModal),
};

export default ConfigureWACampaign;
